module.exports = require("@seddi/three/examples/jsm/postprocessing/Pass.js");